import { NotificationAlertsSettings } from './notification-alerts-settings';
import { LayoutSettings } from './layout-settings';
import { PermissionSettings } from './permission-settings';

export class CustomerSettings {

    public readonly emailAlerts: NotificationAlertsSettings;
    public readonly smsAlerts: NotificationAlertsSettings;
    public readonly layoutSettings: LayoutSettings;
    public readonly permissionSettings: PermissionSettings;
    public readonly hasSmsAlertsNumber: boolean;

    constructor(emailAlerts: NotificationAlertsSettings,
        smsAlerts: NotificationAlertsSettings,
        layoutSettings: LayoutSettings,
        permissionSettings: PermissionSettings,
        hasSmsAlertsNumber = false) {
        this.emailAlerts = emailAlerts;
        this.smsAlerts = smsAlerts;
        this.layoutSettings = layoutSettings;
        this.permissionSettings = permissionSettings;
        this.hasSmsAlertsNumber = hasSmsAlertsNumber;
    }
}